export default __webpack_public_path__ + "static/media/calendarIcon.01e2ba76.svg";